export const filterTopItems = (data: any) => {
  return data?.filter((item: any) => item?.is_top);
};
export const filterStudyAbroad = (data: any) => {
  return data?.filter((item: any) => item?.is_related_study_abroad);
};
export const filterNative = (data: any) => {
  return data?.filter((item: any) => !item?.is_related_study_abroad);
};

export const filterCount = (data: any) => {
  return data?.filter((item: any) => item?.colleges?.count !== 0);
};

export const filterIsAbroadCountry = (entity?: {
  country?: { country_name?: string };
}): boolean => {
  return entity?.country?.country_name
    ? entity.country.country_name !== "India"
    : false;
};
